const backendStaging = () => process.argv.includes('--cloud-api');

const environment = {
  development: {
    isProduction: false,
  },
  test: {
    isProduction: false,
  },
  production: {
    isProduction: true,
  },
}[process.env.NODE_ENV || 'development'];

const config = Object.assign(
  {
    host: process.env.ENDPOINT_FRONTEND
      ? process.env.ENDPOINT_FRONTEND
      : 'fe.local.twine.net',
    port: process.env.FRONTEND_PORT
      ? process.env.FRONTEND_PORT
      : process.env.PORT
      ? process.env.PORT
      : 8080,
    apiHost: process.env.APIHOST
      ? process.env.APIHOST
      : backendStaging()
      ? 'https://staging.twine.net'
      : process.env.ENDPOINT_FRONTEND
      ? `https://${process.env.ENDPOINT_FRONTEND}`
      : 'http://local.twine.net',
    apiPort: process.env.APIPORT
      ? process.env.APIPORT
      : process.env.ENDPOINT_FRONTEND
      ? 443
      : 80,
    baseUrl: process.env.ENDPOINT_FRONTEND
      ? `https://${process.env.ENDPOINT_FRONTEND}`
      : 'http://local.twine.net', // At the moment it's the same as apiHost, but makes sense to keep separate as this could change
    app: {
      title: 'Frontend app',
      head: {
        titleTemplate: '%s',
        title: 'Twine: Hire quality freelancers for your job',
        defaultTitle: 'Twine: Hire quality freelancers for your job',
        description:
          "Twine matches companies to the best digital and creative freelancers from a network of over 260,000. It's free to post a job and you only pay when you hire.",
        meta: [
          {
            name: 'description',
            content:
              "Twine matches companies to the best digital and creative freelancers from a network of over 390,000. It's free to post a job and you only pay when you hire.",
          },
          { charset: 'utf-8' },
          { viewport: 'width=device-width, initial-scale=1' },
          { property: 'og:site_name', content: 'Twine' },
          {
            property: 'og:image',
            content:
              'https://www.twine.net/assets/img/logos/twine-social-icon-min.png',
          },
          { property: 'og:locale', content: 'en_US' },
          {
            property: 'og:title',
            content: 'Twine: Hire quality freelancers for your job',
          },
          { property: 'og:url', content: 'https://www.twine.net/' },
          {
            property: 'og:description',
            content:
              "Twine matches companies to the best digital and creative freelancers from a network of over 390,000. It's free to post a job and you only pay when you hire.",
          },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:site', content: '@jointwine' },
          { name: 'twitter:card', content: 'summary' },
          {
            name: 'twitter:title',
            content: 'Twine: Hire quality freelancers for your job',
          },
          {
            name: 'twitter:description',
            content:
              "Twine matches companies to the best digital and creative freelancers from a network of over 390,000. It's free to post a job and you only pay when you hire.",
          },
          {
            name: 'twitter:image',
            content:
              'https://www.twine.net/assets/img/logos/twine-social-icon-min.png',
          },
        ],
      },
    },
    defaultUserRating: 4,
    defaultNumberOfFreelancersOnLandingPages: 8,
    minimumBudget: 3000,
    stripeKey: 'pk_live_WyBQin3driOenb2RnSvoQSzZ',
    stripeDevKey: 'pk_test_CbXcrPcRicmzINkb3c0B5PIh',
    stripeProducts: {
      pro: {
        usd: {
          month: 'price_1RCimrGtQsaKXkHTLTdzzdhP',
          year: 'price_1RDjRVGtQsaKXkHTfS2c9tu1',
        },
        gbp: {
          month: 'price_1RCikJGtQsaKXkHTkwdViRpL',
          year: 'price_1RDjS8GtQsaKXkHTO2DntnH2',
        },
      },
      premium: {
        usd: {
          month: 'price_1RDjVQGtQsaKXkHTA6W0NWgl',
          year: 'price_1RDjX7GtQsaKXkHTwheQP9FW',
        },
        gbp: {
          month: 'price_1RDjWcGtQsaKXkHT8BFQwxO9',
          year: 'price_1RDjXKGtQsaKXkHTigNqSj7f',
        },
      },
      coupons: {
        pro: {
          usd: {
            year: 'ZgWTkIXQ',
          },
          gbp: {
            year: 'nFnItWv1',
          },
        },
        blackFriday: {
          pro: {
            usd: {
              year: 'LGQV4kE4',
            },
            gbp: {
              year: 'DZSOOo7Q',
            },
          },
          premium: {
            usd: {
              year: 'vKUR8Dnp',
            },
            gbp: {
              year: 'OhBNsz6C',
            },
          },
        },
      },
    },
    stripeProductsDev: {
      pro: {
        usd: {
          month: 'price_1RCiqdGtQsaKXkHTsqHz6b6T',
          year: 'price_1RCizRGtQsaKXkHTy472XY2N',
        },
        gbp: {
          month: 'price_1RCiqIGtQsaKXkHTu2UN49vo',
          year: 'price_1RCiydGtQsaKXkHTUpLgwd9U',
        },
      },
      premium: {
        usd: {
          month: 'price_1RCjeNGtQsaKXkHT5VPMEXtf',
          year: 'price_1RCjfGGtQsaKXkHTIClr3VBl',
        },
        gbp: {
          month: 'price_1RCjewGtQsaKXkHTS0HHGL4G',
          year: 'price_1RCjfVGtQsaKXkHTcMRNnQGD',
        },
      },
      coupons: {
        pro: {
          usd: {
            year: '4ffmTIZt',
          },
          gbp: {
            year: '7oYPRR2a',
          },
        },
        blackFriday: {
          pro: {
            usd: {
              year: 'BiBK1Lni',
            },
            gbp: {
              year: '9EMmIXRQ',
            },
          },
          premium: {
            usd: {
              year: 'eU6aV7aG',
            },
            gbp: {
              year: 'pAM3Z5Vc',
            },
          },
        },
      },
    },
    WSSEndpoint: 'wss://gyj5y94he1.execute-api.us-east-1.amazonaws.com/Prod',
    WSSEndpointDev: 'wss://fcd9qig3o6.execute-api.eu-west-2.amazonaws.com/Prod',
    GTMEndpoint:
      environment.isProduction &&
      process.env.ENDPOINT_FRONTEND === 'www.twine.net'
        ? 'GTM-TKR9N6Z'
        : 'GTM-WZR75XC',
    testingGTMLocally: process.env.TESTING_GTM_LOCALLY == 'true',
    partnerImages:
      environment.isProduction &&
      process.env.ENDPOINT_FRONTEND === 'www.twine.net'
        ? 'https://twine-partners.s3.amazonaws.com'
        : 'https://twine-partners-staging.s3.amazonaws.com',
  },
  environment
);

export default config;
